module.exports = __webpack_public_path__ + "img/img_shouye_zijin_three@2x.90b27285.png";